/**
 * 4STARS — przełącznik sal nad grafikiem
 *
 * Umieść w: src/components/roomSwitcher.jsx
 *
 * ── UŻYCIE w location.jsx ────────────────────────────────────────────────────
 *
 *   import { useSchedule } from "../data/useLocations";
 *   import RoomSwitcher from "../components/roomSwitcher";
 *   import ScheduleSoon, { ScheduleSkeleton } from "../components/scheduleSoon";
 *
 *   const {
 *     rooms, activeRoomId, setActiveRoomId, hasMultipleRooms,
 *     groups, status, note, seasonLabel,
 *   } = useSchedule(location);
 *
 *   <h2 className="schedule_title">Grafik zajęć</h2>
 *
 *   {hasMultipleRooms && (
 *     <RoomSwitcher
 *       rooms={rooms}
 *       activeId={activeRoomId}
 *       onChange={setActiveRoomId}
 *       color={location?.color}
 *     />
 *   )}
 *
 *   {status === "loading"   && <ScheduleSkeleton color={location?.color} />}
 *   {status === "soon"      && <ScheduleSoon color={location?.color} note={note}
 *                                            seasonLabel={seasonLabel}
 *                                            locationName={location?.name} />}
 *   {status === "published" && <Schedule groups={groups} />}
 */

import React from "react";

export default function RoomSwitcher({ rooms = [], activeId, onChange, color = "#d0142d" }) {
  if (!rooms.length) return null;

  return (
    <div
      role="tablist"
      aria-label="Wybór sali"
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        width: "100%",
        margin: "6px auto 22px",
      }}
    >
      {rooms.map((room) => {
        const isActive = room.id === activeId;
        const isSoon = room.status === "soon";

        return (
          <button
            key={room.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange?.(room.id)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              border: isActive ? `1px solid ${color}` : "1px solid rgba(0,0,0,0.12)",
              backgroundColor: isActive ? color : "rgba(255,255,255,0.95)",
              color: isActive ? "rgb(250,250,250)" : "rgba(0,0,0,0.82)",
              borderRadius: "999px",
              padding: "11px 22px",
              fontSize: "13px",
              fontWeight: 800,
              cursor: "pointer",
              transition: "background-color 140ms ease, color 140ms ease",
              boxShadow: isActive ? "0 6px 16px rgba(0,0,0,0.14)" : "none",
              lineHeight: 1,
            }}
          >
            {room.label}

            {/* kropka przy salach bez gotowego grafiku */}
            {isSoon && (
              <span
                aria-label="grafik w przygotowaniu"
                title="Grafik w przygotowaniu"
                style={{
                  width: "7px",
                  height: "7px",
                  borderRadius: "999px",
                  backgroundColor: isActive ? "rgba(255,255,255,0.85)" : "rgba(0,0,0,0.28)",
                  flex: "0 0 auto",
                }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
